"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  data: function data() {
    return {
      defaultData: [{
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png',
        name: '请先选择专场',
        desc: '开拍时间：2022年10月28日 10:00\n预展时间：2022年10月28日 10:00'
      }]
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    viewData: function viewData() {
      if (this.content.data.length > 0) {
        return this.content.data;
      } else {
        return this.defaultData;
      }
    },
    imgPadding: function imgPadding() {
      if (this.facade.img_position === 'left') {
        return "".concat(this.facade.item_padding / 2, "px ").concat(this.facade.item_padding / 2, "px 0 0");
      } else if (this.facade.img_position === 'right') {
        return "".concat(this.facade.item_padding / 2, "px 0 0 ").concat(this.facade.item_padding / 2, "px");
      } else {
        return '0';
      }
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面渲染前
   * @return {[type]} [description]
   */
  created: function created() {},
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {}
};
exports.default = _default;